import React from 'react';
import SearchIcon from '../icons/search.svg'
import { useSelector } from 'react-redux'
import { getSearchSuggestions } from '../../actions/filterActions'
import { useDispatch } from 'react-redux'
import { HighlightedText } from '../../utils/HighlightText'


const SearchComponent = (props) => {

    const [searchActive, setSearchActive] = React.useState(false)

    const {searchSuggestions, loadingSuggestions, message} = useSelector(state=>state.searchSuggestions)

    const dispatch = useDispatch()

    const handleKeyDown = (e) => {
        if(e.code === "Enter"){
            props.searchFun(props.searchValue, 1, 1)
            setSearchActive(false)
        }
    }


    React.useEffect(()=>{
        const identifer = setTimeout(()=>{
            if (props.searchValue){
                dispatch(getSearchSuggestions(props.searchValue))
                setSearchActive(true)
            } else {
                setSearchActive(false)
            }
        }, 500)  
        
        return () => { clearTimeout(identifer) }
    
    },[props.searchValue])


    const chooseHandler = (value) => {
        props.searchFun(value, 1, 1)
        setSearchActive(false)
      }

    const onSearchClick = () => {
        props.searchFun(props.searchValue, 1, 1)
        setSearchActive(false)
    }   
    

    return (
        <div className = "w-100 d-flex flex-column py-4">
            <div className = "w-100 d-flex position-relative px-3 px-md-0">
                <div className=' w-100 py-3 border-bottom border-1 border-info d-flex align-items-center'>
                    <input
                        type="text"
                        data-tooltip-id="new-tooltip"  
                        data-tooltip-content="For more search options, press the filter button on the right!"
                        className="fs-5 ps-2 w-100 border-0 text-white search-input bg-backcolor"
                        placeholder="Search by title..."
                        onChange={(e)=>{props.setSearchValue(e.target.value)}}
                        // onClick={()=>setSearchActive(true)}                        
                        value={props.searchValue}
                        onKeyDown={handleKeyDown}
                    />
                </div>
                <div className='ps-4'>
                    <img 
                        style={{width: "1.5rem", height:"1.5rem"}}
                        src = {SearchIcon}
                        alt = "search icon"
                        role='button'
                        onClick={()=>onSearchClick()}
                    />
                </div>
            </div>           
            {
                searchActive ?
                loadingSuggestions ? 
                <div className='w-100 text-info position-relative p-2 rounded'
                    style={{zIndex:'1000'}}
                >Loading...</div> :
                searchSuggestions && searchSuggestions.length ?
                <div className = "w-100 position-relative p-2 rounded" 
                    style = {{color:"#333", zIndex:1000}}>
                        {
                        searchSuggestions.map((result) => (
                            <div
                                className = "p-2 text-info addSearchDropdown-item rounded"
                                role = "button"
                                style={{transition:"all 0.2s"}}
                                key = {result.id}
                                // onClick = {()=>chooseHandler(result.title)}
                            >
                                <HighlightedText 
                                    text={result.title} 
                                    highlight={props.searchValue} 
                                    onClick={()=>chooseHandler(result.title)}
                                />
                            </div>
                        ))
                        }
                </div> : 
                message ?
                <div className='w-100 text-info position-relative p-2 rounded'>
                    {message}
                </div> : "" : ""
            }
        </div>
    );
};

export default SearchComponent;